<script>
	export default {
		name: 'CustomBriLifeExecuter',
		methods: {
			customBriLifeSetFirestore() {
				const self_ = this;

				const set_ = (key, doc) => {
					return self_.setFirestoreSubDocument('contents', 'app', 'menuItems', key, doc)
				}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreSubCollection('contents', 'app', 'menus')
					}).then(result => {
						let promiseArray_ = []
						Object.keys(result).forEach(key => {
							promiseArray_.push(set_(key,result[key]))
						})
						return Promise.all(promiseArray_)
					}).then(() => {
						self_.setDebugState('result', ['finished'])

						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			customBriLifeUpdateUser(username, email, phone) {
				const self_ = this;

				let uid_ = null;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getUserByUsername(username)
					}).then(result => {
						uid_ = result.uid;
						return self_.ipCliUpdateAppUsers(uid_, { email: email, phone: phone })
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			customBriLifeSendNotificationEmail() {
				const self_ = this;

				let result_ = []

				const sendEmail_ = (username, password, email, timeout) => {
					setTimeout(() => {
						const sender_ = 'admin.mylife@brilife.co.id';

						const subjectFlashSale_ = 'Program Merdeka - DISKON POIN hingga 75%';
						const htmlFlashSale_ = `
							Semangat Pagi BRILIFERS, <br>
							<br>
							Memperingati HUT kemerdekaan RI yang ke 75, ada program baru loh yang bisa kamu ikuti. Yaitu DISKON MERDEKA DAN UNDIAN MERDEKA.<br>
							<br>
							<br>
							BRILIFERS  bisa menukarkan poin yang dimiliki untuk mendapatkan produk Undian Merdeka dimulai dari 10 poin dan juga pilihan produk Diskon Merdeka sampai dengan 75% off.<br>
							<br>
							<br>
							Yuk cek produknya sekarang di rewardzone.web.app<br>
							<br>
							Dan tolong gunakan username dan kata sandi sementara dibawah ini untuk mengakses link website di atas: <br>
							<br>
							username = <b>` + username + `</b><br>
							Kata sandi sementara = <b>` + password +`</b><br>
							<br>
							<br>
							<span style="color:red">Note : Kata sandi bisa diganti dengan yang baru sesuai keinginan, jika sudah masuk ke dalam akun.</span>
							<br>
							Jangan lupa login dan update password kamu ya.<br>
							<br>
							Atas perhatiannya, terima kasih.
						`

						const subjectRegister_ = 'Pemberitahuan Pendaftaran Pengguna';
						const htmlRegister_ = `
							Semangat Pagi BRILIFERS, <br>
							<br>
							Terima kasih telah mendaftar di <span style="color: red">New Version of Reward Zone</span>.<br>
							Tujuan dari pesan ini adalah untuk memberitahukan kepada Anda bahwa proses pendaftaran pengguna telah selesai.<br>
							Anda dapat menggunakan tautan dan informasi di bawah ini untuk melakukan login ke sistem.<br>
							<br>
							<br>
							BRI Life Reward Zone<br>
							<span style="color: blue">https://rewardzone.web.app</span><br>
							<br>
							Username = <b>` + username + `</b><br>
							Kata sandi semantara = <b>` + password + `</b><br>
							<br>
							<span style="color: red">Setelah Anda menerima pesan ini, mohon ubah kata sandi Anda.</span><br>
							<br>
							<br>
							Hormat Kami,<br>
							BRI LIFE
						`

						// const subject_ = subjectFlashSale_;
						// const html_ = htmlFlashSale_;

						const subject_ = subjectRegister_;
						const html_ = htmlRegister_;

						const body_ = {
							to: email,
							from: sender_,
							subject: subject_,
							html: html_
						}

						const bodyBcc_ = {
							to: 'd.hayashi@benefit-one.co.id',
							from: sender_,
							subject: subject_ + ' (' + email +')',
							html: html_
						}

						return new Promise((resolve, reject) => {
							Promise.resolve().then(() => {
								return self_.sendGridPost(body_)
							}).then(() => {
								return self_.sendGridPost(bodyBcc_)
							}).then(() => {
								result_.push(username + ' finished')
								resolve()
							}).catch(error => {
								reject(error)
							})
						})
					}, timeout)
				}

				let promiseArray_ = []
				// promiseArray_.push(sendEmail_('admin','c679292499ab','d.hayashi@benefit-one.co.id',0))
				
				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return Promise.all(promiseArray_)
					}).then(() => {
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			}
		}
	}
</script>